const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnUnlockXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.249 108.714h-8.417V106a3.035 3.035 0 1 1 6.045 0 .682.682 0 1 0 1.365 0 4.4 4.4 0 1 0-8.775 0v2.716h-1.138a1.372 1.372 0 0 0-1.365 1.377v8.948a1.372 1.372 0 0 0 1.365 1.377h10.92a1.373 1.373 0 0 0 1.365-1.377v-8.948a1.373 1.373 0 0 0-1.365-1.379zm0 10.325h-10.92v-8.948h10.921z",
    transform: "translate(-909.789 -98.861)",
    style: {
      fill: "current",
      stroke: "#fff",
      strokeWidth: ".4px"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnUnlockXs);
export default __webpack_public_path__ + "static/media/btn-unlock-xs.6bf636a73dc6ec5686a53667850c7042.svg";
export { ForwardRef as ReactComponent };